export const downloadBlobFile = (blob: Blob, fileName: string) => {
  const a = document.createElement('a')
  a.download = fileName
  a.href = URL.createObjectURL(blob)
  document.body.appendChild(a)
  a.click()
  a.remove()
}
